import React, { ReactNode } from 'react';

import {
  WidgetDefaultSigninImage,
  WidgetDefaultSignupImage,
  WidgetPasswordlessCodeImage,
  WidgetPasswordlessImage,
  WidgetSocialsImage
} from '../../../assets/widget-preview-image';
import { getRandomString } from '../../../utils';
import { ImageView, ViewWrapper } from './style';

type Props = {
  methodName: string;
};

type LoginList = {
  [key: string]: ReactNode[];
};

const LoginImageList: LoginList = {
  classic: [<WidgetDefaultSigninImage />, <WidgetDefaultSignupImage />],
  passwordless: [<WidgetPasswordlessImage />, <WidgetPasswordlessCodeImage />],
  social: [<WidgetSocialsImage />]
};

const LoginMethodView = ({ methodName }: Props): JSX.Element => {
  return (
    <ViewWrapper>
      {LoginImageList[methodName].map((src) => {
        return <ImageView key={getRandomString()}>{src}</ImageView>;
      })}
    </ViewWrapper>
  );
};

export default LoginMethodView;
